module.exports = __webpack_public_path__ + "static/media/EnhanceInitiative.207832d5.gif";